export enum ActiveTenant {
    "SW-FOOD" = "SW-FOOD",
    DASH = "DASH",
}
